import { render, staticRenderFns } from "./check-boxes.vue?vue&type=template&id=31610338&"
import script from "./check-boxes.vue?vue&type=script&lang=js&"
export * from "./check-boxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports